import { render, staticRenderFns } from "./PersonalInformationConsent.vue?vue&type=template&id=c0b505a8&scoped=true&"
import script from "./PersonalInformationConsent.vue?vue&type=script&lang=js&"
export * from "./PersonalInformationConsent.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInformationConsent.vue?vue&type=style&index=0&id=c0b505a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b505a8",
  null
  
)

export default component.exports